<template>
  <div
    class="statisticsRows-ligne"
    :class="{'is-radius-large': !isTotal}"
    v-if="sale">
    <div
      v-if="!isTotal"
      class="is-radius-top-left-large is-radius-top-right-large"></div>
    <div class="columns is-gapless">
      <div class="column is-2 columns is-gapless is-vcentered is-marginless">
        <div class="column is-7 is-padding-left-small is-padding-right-small is-padding-top-small is-padding-bottom-small">
          <strong
            class="entityName"
            :class="{'is-size-6': !isTotal}"
            v-if="sale.user_name">
            <router-link
              v-if="sale.user_pk && sale.user_pk !== currentUserPk"
              :to="{ name: 'UserVue', params: { id: sale.user_pk } }">{{ sale.user_name }}</router-link>
            <span v-else>{{ sale.user_name }}</span>
          </strong>
          <span
            class="is-size-6"
            v-else>--</span>
          <br>
        </div>
        <div class="column is-5 is-padding-left-small is-padding-right-small is-padding-top-small is-padding-bottom-small">
          <span
            class="has-text-grey is-size-6"
            v-if="sale.account_name">
            <router-link
              class="has-text-grey"
              v-if="sale.account_pk && sale.account_pk !== accountPk"
              :to="{ name: 'CompanyVue', params: { id: sale.account_pk } }">{{ sale.account_name }}</router-link>
            <span v-else>{{ sale.account_name }}</span>
          </span>
          <span
            class="has-text-grey is-size-6"
            v-else-if="!isTotal">--</span>
        </div>
      </div>
      <div
        class="column columns is-gapless is-vcentered is-marginless"
        :class="hasColProgram ? 'is-6' : ''">
        <div
          v-if="!hasColProgram"
          class="column is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <router-link
            v-if="!isTotal && sale.ref"
            class="is-size-6 is-hover-underline"
            :to="{name: 'AdvInfos', params: {id: sale.pk}}">
            {{ sale.ref }}
          </router-link>
          <span
            class="is-size-6"
            v-else-if="!isTotal">--</span>
          <br>
        </div>
        <div
          v-if="hasColProgram"
          class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <span
            class="is-size-6"
            v-if="!isTotal && sale.program_name">{{ sale.program_name }}</span>
          <span
            class="is-size-6"
            v-else-if="!isTotal">--</span>
          <br>
        </div>
        <div
          class="column is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small"
          :class="hasColProgram ? 'is-2' : ''">
          <span
            class="is-size-6"
            v-if="!isTotal && sale.lot_ref">{{ sale.lot_ref }}</span>
          <span
            class="is-size-6"
            v-else-if="!isTotal">--</span>
          <br>
        </div>
        <div
          class="column is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small"
          :class="hasColProgram ? 'is-2' : ''">
          <span
            class="is-size-6"
            v-if="sale.contact_name">{{ sale.contact_name }}</span>
          <span
            class="is-size-6"
            v-else-if="!isTotal">--</span>
          <br>
        </div>
        <div
          class="column is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small"
          :class="hasColProgram ? 'is-2' : ''"
          v-if="!isTotal">
          <span
            class="is-size-6"
            v-if="sale.origin_name">{{ sale.origin_name }}</span>
          <span
            class="is-size-6"
            v-else>--</span>
          <br>
        </div>
        <div
          class="column is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small"
          :class="hasColProgram ? 'is-2' : ''"
          v-else>
          Total ventes<br>
          <b>{{ sale.sale_count }}</b>
          <br>
        </div>
        <div class="column is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small is-3">
          <span v-if="isTotal">Total prix immo<br></span>
          <stat-value
            v-if="sale.sale_price_ttc"
            :value="sale.sale_price_ttc"
            :euro="true"
            :total="isTotal"
            :class="{'has-text-weight-bold': isTotal}"></stat-value>
          <span v-else>--</span>
          <br>
        </div>
      </div>
      <div
        class="columns is-gapless column is-4 is-border-left is-vcentered is-marginless"
        :class="{'has-background-light': !isTotal}">
        <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <span v-if="isTotal">Com Vendeur<br></span>
          <stat-value
            v-if="sale.seller_com"
            :value="sale.seller_com"
            :euro="true"
            :total="isTotal"
            :class="{'has-text-weight-bold': isTotal}"></stat-value>
          <br>
        </div>
        <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <span v-if="isTotal">Com Société<br></span>
          <stat-value
            v-if="sale.company_com"
            :value="sale.company_com"
            :euro="true"
            :total="isTotal"
            :class="{'has-text-weight-bold': isTotal}"></stat-value>
          <br>
        </div>
        <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <span v-if="isTotal">Total Com Vente<br></span>
          <stat-value
            v-if="sale.CA"
            :value="sale.CA"
            :euro="true"
            :total="isTotal"
            :class="{'has-text-weight-bold': isTotal}"></stat-value>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StatsSalesRow',
  components: {
    StatValue: () => import('@/components/statistics/StatValue')
  },
  props: {
    hasColProgram: {
      type: Boolean,
      default: true
    },
    sale: {
      type: Object,
      required: true
    },
    isTotal: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    ...mapGetters(['accountPk', 'currentUserPk'])
  }
}
</script>

<style lang="sass">
  .vue-swatches.colorPicker
    .vue-swatches__trigger
      display: block
</style>
